import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Icons } from '@ge/components/icon';
import { Textarea } from '@ge/components/textarea';

import {
  AddNoteFormRow,
  DialogLabel,
  EventNoteContainerHeading,
  StyledIconButtonIcon,
} from './event-dialog-style';

export const MalEventNotesText = ({ name, label, defaultValue, placeholder }) => {
  const { control } = useFormContext();

  return (
    <AddNoteFormRow>
      <EventNoteContainerHeading>
        <StyledIconButtonIcon className="notesIcon" icon={Icons.NOTE} size={12} />
        <DialogLabel>{label}</DialogLabel>
      </EventNoteContainerHeading>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ value, onChange }) => (
          <Textarea
            placeholder={placeholder}
            value={value}
            onChange={(event) => {
              const val = event.target.value;
              onChange(val);
            }}
          />
        )}
      />
    </AddNoteFormRow>
  );
};

MalEventNotesText.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
};

MalEventNotesText.defaultProps = {
  defaultValue: '',
};
